import { InputOtpDesignTokens } from '@primeuix/themes/aura/inputotp';

export const inputOtpTokens: InputOtpDesignTokens = {
  root: {
    gap: '0.5rem',
  },
  input: {
    width: '2.5rem',
    sm: {
      width: '2rem',
    },
    lg: {
      width: '3rem',
    },
  },
};
